import { useAppDispatch, useFlowState, useSeekerCCState } from '@/components/AppState';
import { useFeatureFlags } from '@/components/FeatureFlagsContext';
import useFlowNavigation from '@/components/features/flowNavigation/useFlowNavigation';
import { useRouter } from 'next/router';
import { CLIENT_FEATURE_FLAGS, FLOWS, SEEKER_INSTANT_BOOK_ROUTES } from '@/constants';
import { DefaultCareKind } from '@/types/seekerCC';
import { AnalyticsHelper } from '@/utilities/analyticsHelper';

export function useIBFlowHelper() {
  const { flowName } = useFlowState();
  const {
    careKind,
    instantBook: { eligibleLocation },
  } = useSeekerCCState();
  const dispatch = useAppDispatch();
  const featureFlags = useFeatureFlags();
  const router = useRouter();
  const { goNext } = useFlowNavigation();
  const instantBookFlag =
    featureFlags?.flags[CLIENT_FEATURE_FLAGS.INSTANT_BOOK_ENROLLMENT_DIRECT_TO_BOOKING];
  const instantBookFlagValue = instantBookFlag?.value;

  function goToIBNextStep(skipNext?: boolean) {
    if (eligibleLocation && careKind === DefaultCareKind.ONE_TIME_BABYSITTERS) {
      AnalyticsHelper.logTestExposure(
        CLIENT_FEATURE_FLAGS.INSTANT_BOOK_ENROLLMENT_DIRECT_TO_BOOKING,
        instantBookFlag
      );

      if (instantBookFlagValue === 2 && flowName === FLOWS.SEEKER_CHILD_CARE.name) {
        dispatch({ type: 'setFlowName', flowName: FLOWS.SEEKER_INSTANT_BOOK.name });
        router.push(SEEKER_INSTANT_BOOK_ROUTES.WHO);
      } else {
        goNext(skipNext);
      }
    } else {
      goNext(skipNext);
    }
  }

  return {
    goToIBNextStep,
  };
}
